import { useState } from "react";
import { useResendEmail as useResendEmailBase } from "@b2bportal/core-self-serve/overridable";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { BookingType } from "@overrides/types";

export function useResendEmail(
  reservationId: string,
  reservationType: BookingType,
  isLuxuryHotel = false
) {
  const { t } = useI18nContext();
  const [submittedEmail, setSubmittedEmail] = useState("");
  const result = useResendEmailBase(
    reservationId,
    reservationType,
    isLuxuryHotel
  );

  const originalOnSubmit = result.handlers.onSubmit;

  return {
    ...result,
    copy: {
      ...result.copy,
      success: {
        ...result.copy.success,
        subtitle: t("core-self-serve.resend-email.success.subtitle", {
          email: submittedEmail,
        }),
      },
    },
    handlers: {
      ...result.handlers,
      onSubmit: async (email: string) => {
        setSubmittedEmail(email);
        return originalOnSubmit(email);
      },
    },
  };
}
